export default [
    {
        title: "Dashboard",
        route: "dashboard"
    },
    {
        title: "Lista pagine",
        route: "genericlanding.list"
    },
];
